import { render, staticRenderFns } from "./StoreGoods.vue?vue&type=template&id=00c89b35&scoped=true"
import script from "./StoreGoods.vue?vue&type=script&lang=js"
export * from "./StoreGoods.vue?vue&type=script&lang=js"
import style0 from "./StoreGoods.vue?vue&type=style&index=0&id=00c89b35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c89b35",
  null
  
)

export default component.exports